import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

const requestId = document.querySelector('meta[name=request_id]')?.getAttribute('content') ?? '';

export const bootstrap = new BootstrapBrowserBuilder('rent-payment-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: `/renter-hub/payments/log?requestId=${requestId}`,
  })
  .withOnRegister(analytics.initialize)
  .build();
